import React from 'react'
import ManageBooksDetail from '../manage-books/ManageBooksDetail';
import { ELibraryCategory } from '../../enum/elibrary_enum';
import { routeName } from '../../../../routes/routeName';

type Props = {
    view: boolean;
}

const ManageEbooksDetail: React.FC<Props> = ({ view }: Props) => {

    return (
        <ManageBooksDetail
            view={view}
            library_category_name={ELibraryCategory.E_BOOK}
            menu_name='จัดการE-Book'
            menu_name_detail='เพิ่มE-Book'
            menu_path_name={routeName.e_library.manage_e_books}
        />
    )
}

export default ManageEbooksDetail